export const SubSectionLabel = ({ label }: { label: string }) => (
  <p className="text-xs font-medium text-muted-foreground">{label}</p>
);
